/**
 * @file ActivateSortableJS の適用
 */
'use strict';

import Sortable from 'sortablejs'

/**
 * @classname ActivateSortableJS
 * @classdesc SortableJS の適用
 */
export default class ActivateSortableJS {
	/**
	 * @constructor
	 * @param sortableListElement HTMLElement
	 */
	constructor(sortableListElement) {
		console.log('ActivateSortableJS.constructor')
		this._element = sortableListElement
		this.activation()
	}


	/**
	 * 起動
	 *
	 * @memberof ActivateSortableJS
	 * @return {undefined}
	 */
	activation() {
		console.log('ActivateSortableJS.activation')
		const sortable = new Sortable(this._element, {
			animation: 100,
			handle: '.sortable-list__item__handle',
		})
	}
}
